import { useEffect, useState } from 'react';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { useAuth0Token } from './useAuth0Token';

export const useReferencedComponent = (documentId: string) => {
  const [component, setComponent] = useState<any>(null);
  const { simpleToken } = useAuth0Token();
  const hasToken = !!simpleToken;

  // Refetched once a token is available, to include member content.
  useEffect(() => {
    const controller = new AbortController();

    apiClient
      .get(ApiType.apimNafNoApi, {
        url: ApiPaths[ApiType.apimNafNoApi].component.get(documentId),
        signal: controller.signal,
      })
      .then((res) => setComponent(res.data))
      .catch(() => {
        // No error UI; keep what was fetched before.
      });

    return () => controller.abort();
  }, [documentId, hasToken]);

  return component;
};
